<template>
    <div>
        <div
            :id="toolTipTarget"
            class="file-list-item-wrapper clickable"
            @click="click()"
        >
            <div>
                <BaseIcon class="noselect" :name="nodeIcon()" size="1x" />
            </div>
            <div>
                {{ title }}
            </div>
            <div>
                {{ getDate() }}
            </div>
            <div>
                <a
                    v-if="isNodeUrl()"
                    target="_blank"
                    :href="description"
                    style="color:black;"
                >
                    <BaseIcon
                        class="noselect"
                        name="external-link-alt"
                        size="1x"
                    />
                </a>
                <a
                    v-else
                    target="_blank"
                    :href="downloadUrl"
                    style="color:black;"
                    download=""
                >
                    <BaseIcon class="noselect" name="download" size="1x" />
                </a>
            </div>
        </div>
        <b-tooltip v-if="hasTooltip" :target="toolTipTarget" triggers="hover">
            {{ tooltip }}
        </b-tooltip>
        <hr style="border-bottom: #f3f3f3; margin:0;" />
    </div>
</template>

<script>
import dateToString from '~/utils/dateToString';

export default {
    name: 'FileListItem',
    props: {
        id: String,
        fileType: String,
        title: String,
        published: String,
        downloadUrl: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        thumbnail: {
            type: String,
            default: '',
        },
    },
    computed: {
        hasTooltip() {
            return !this.isNodeUrl() && this.description.trim() !== '';
        },
        tooltip() {
            return this.description;
        },
        toolTipTarget() {
            return 'tooltip_' + this.id;
        },
    },
    methods: {
        getExtension(fileName) {
            const split = fileName.split('.');
            if (split.length > 1) {
                return split.pop();
            } else {
                return '';
            }
        },
        getDate() {
            return dateToString(this.published);
        },
        click() {
            window.open(this.linkUrl(), '_blank');
        },
        isNodeUrl() {
            return (
                this.description !== undefined && this.isUrl(this.description)
            );
        },
        isUrl(name) {
            return (
                name.toLowerCase().startsWith('http://') ||
                name.toLowerCase().startsWith('https://') ||
                name.toLowerCase().startsWith('mailto:')
            );
        },
        linkUrl() {
            if (this.isNodeUrl()) {
                return this.description;
            } else {
                return this.downloadUrl;
            }
        },
        nodeIcon() {
            if (this.isNodeUrl()) {
                return this.fileIcon('uri');
            } else {
                return this.fileIcon(this.getExtension(this.title));
            }
        },
        fileIcon(fileType) {
            let icon = 'file-alt';
            switch (fileType) {
                case 'png':
                case 'jpeg':
                case 'bmp':
                case 'jpg':
                    icon = 'file-image';
                    break;
                case 'pdf':
                    icon = 'file-pdf';
                    break;
                case 'doc':
                case 'rtf':
                case 'docx':
                    icon = 'file-word';
                    break;
                case 'txt':
                    icon = 'file-alt';
                    break;
                case 'uri':
                    icon = 'link';
                    break;
                case 'ppt':
                case 'pptx':
                case 'potx':
                case 'potm':
                case 'sldx':
                    icon = 'file-powerpoint';
                    break;
                case 'xls':
                case 'xlsm':
                case 'xlsx':
                    icon = 'file-excel';
                    break;
                default:
                    break;
            }
            return icon;
        },
    },
};
</script>

<style scoped>
.file-list-item-wrapper {
    display: grid;
    grid-template-columns: 1fr 5fr 4fr 3fr;
    grid-gap: 10px;
    padding: 10px;
    font-size: 14px;
}
</style>
